import endpoints, { axios } from "../config/api";

function getAddableDependancyTemplateTasksByIds(selectedIds: string) {
  return axios.get(
    endpoints.taskTemplates.getAddableTaskDependanciesByIds(selectedIds)
  );
}

export default getAddableDependancyTemplateTasksByIds;
